import { ResultType } from '../PreviewYesNoSplitModal.constants';
import SingleResult from './SingleResult';
import { Wrapper } from './SplitResult.styles';

export interface SplitResultProps {
  /** Where this user will end up in the yes/no split */
  result?: ResultType;
  /** Is the component loading? */
  loading?: boolean;
}

export const SPLIT_RESULT_TEST_ID = 'split-result';

const SplitResult = ({ result = ResultType.Unknown, loading = false }: SplitResultProps) => {
  return (
    <Wrapper
      data-test={SPLIT_RESULT_TEST_ID}
      data-result={result}
      isLoading={loading}
      shimmerSpeed={1500}
    >
      <SingleResult actual={result} expected={ResultType.Yes}>
        Yes
      </SingleResult>
      <SingleResult actual={result} expected={ResultType.No}>
        No
      </SingleResult>
    </Wrapper>
  );
};

export default SplitResult;
